<div class="header-wrapper">
    <a (click)="onToggleClick()">
        <span class="close"></span>
    </a>
</div>
<div class="wrapper">
    <ng-content></ng-content>
</div>
<div class="collapse-wrapper">
    <button (click)="onToggleClick()" tabindex="0">
        <span *ngIf="showProzessNavigation" class="arrow-left" [title]="'navigation.collapse' | translate"></span>
        <span *ngIf="!showProzessNavigation" class="arrow-right" [title]="'navigation.expand' | translate"></span>
    </button>
</div>